export enum CountryShortcuts {
  POLAND = 'PL',
}
